import { createActions, createReducer } from 'reduxsauce'

import ConsultaEstagiariosMPService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaEstagiariosMPInicio: [],
    buscaConsultaEstagiariosMPErro: ['erro'],
    buscaConsultaEstagiariosMPSucesso: ['consultaEstagiariosMP'],
    limpar: [],
    setConsultaEstagiariosMPEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.consultarQuadrosMembros = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaEstagiariosMPInicio())
        let serv = new ConsultaEstagiariosMPService()
        return serv
            .consultarQuadrosMembros(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaConsultaEstagiariosMPSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaEstagiariosMPErro(error)))
    }
}

const buscaConsultaEstagiariosMPInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaEstagiariosMPErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaEstagiariosMPSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaEstagiariosMP.resultado,
        dataSincronizacaoDados: action.consultaEstagiariosMP.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaEstagiariosMPEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_ESTAGIARIOS_MP_INICIO]: buscaConsultaEstagiariosMPInicio,
    [Types.BUSCA_CONSULTA_ESTAGIARIOS_MP_ERRO]: buscaConsultaEstagiariosMPErro,
    [Types.BUSCA_CONSULTA_ESTAGIARIOS_MP_SUCESSO]: buscaConsultaEstagiariosMPSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_ESTAGIARIOS_MP_ESTADO_DT]: setConsultaEstagiariosMPEstadoDT,
})
